const PROTOCOL_WHITELIST = new Set(['http:', 'https:', 'ton:', 'mailto:', 'tel:', 'sc:', 'spacechat:']);
const FALLBACK_PREFIX = 'https://';

export function ensureProtocol(url?: string) {
  if (!url) {
    return undefined;
  }

  try {
    const parsedUrl = new URL(url);
    // eslint-disable-next-line no-script-url
    if (!PROTOCOL_WHITELIST.has(parsedUrl.protocol)) {
      return `${FALLBACK_PREFIX}${url}`;
    }

    return url;
  } catch (err) {
    return `${FALLBACK_PREFIX}${url}`;
  }
}

export function isUrlValid(url?: string): boolean {
  if (!url || !url.trim()) return false;

  const trimmed = url.trim();

  try {
    const parsedUrl = new URL(trimmed);
    if (PROTOCOL_WHITELIST.has(parsedUrl.protocol)) return true;
  } catch {
    // URL parsing failed — fall through to bare-domain check
  }

  // Try as a bare domain with https://
  try {
    const withProtocol = new URL(`${FALLBACK_PREFIX}${trimmed}`);
    const { hostname } = withProtocol;
    return hostname.includes('.') || hostname === 'localhost';
  } catch {
    return false;
  }
}
